"use strict";
angular.module("internal.exams")
    .controller("InternalExamAutomationCorrespondences", ["$scope", "MergeTemplates", "MergeContactGroups", function (
        $scope,
        MergeTemplates,
        MergeContactGroups) {

        $scope.loading = true;
        MergeTemplates.getExamsTemplates(true).then(function (ExamTemplates) {
            $scope.ExamTemplates = ExamTemplates;
            $scope.loading = false;

            $scope.ExamTemplates.forEach(function (ExamTemplate) {
                ExamTemplate.toList = '';
                ExamTemplate.fromList = '';
                ExamTemplate.replyToList = '';
                if (ExamTemplate.to_address != null) {
                    ExamTemplate.toList = ExamTemplate.to_address.replace(/,/g, "; ");
                }
                if (ExamTemplate.replyto_address != null) {
                    ExamTemplate.replyToList = ExamTemplate.replyto_address.replace(/,/g, "; ");
                }
                if (ExamTemplate.from_address != null) {
                    ExamTemplate.fromList = ExamTemplate.from_address.replace(/,/g, "; ");
                }
                if (ExamTemplate.to_contact_groups != null) {
                    var arr = ExamTemplate.to_contact_groups.split(',');
                    arr.forEach(function (item) {
                        MergeContactGroups.getByID(item).then(function (group) {
                            if (ExamTemplate.toList != null && ExamTemplate.toList != '') {
                                ExamTemplate.toList += '; '
                            }
                            ExamTemplate.toList += group.name;
                        })
                    });
                }
                if (ExamTemplate.replyto_contact_groups != null) {
                    var arr = ExamTemplate.replyto_contact_groups.split(',');
                    arr.forEach(function (item) {
                        MergeContactGroups.getByID(item).then(function (group) {
                            if (ExamTemplate.replyToList != null && ExamTemplate.replyToList != '') {
                                ExamTemplate.replyToList += '; '
                            }
                            ExamTemplate.replyToList += group.name;
                        })
                    });
                }
                if (ExamTemplate.from_contact_groups != null) {
                    var arr = ExamTemplate.from_contact_groups.split(',');
                    arr.forEach(function (item) {
                        MergeContactGroups.getByID(item).then(function (group) {
                            if (ExamTemplate.fromList != null && ExamTemplate.fromList != '') {
                                ExamTemplate.fromList += '; '
                            }
                            ExamTemplate.fromList += group.name;
                        })
                    });
                }
            });



        });

        $scope.columns = [{
            label: "Name",
            field: "name",
            link: {
                state: "internal.exams.administrative.correspondence",
                params: [{
                    name: "examTemplateID",
                    field: "id"
                }]
            }
        }, {
            label: "To",
            field: "toList"
        }, {
            label: "From",
            field: "fromList"
        }, {
            label: "Reply To",
            field: "replyToList"
        }, {
            label: "Subject",
            field: "subject"
        }, {
            label: "Description",
            field: "description"
        }, {
            label: "Last Modified",
            field: "modifiedon",
            type: "datetime"
        }, {
            label: "Modified By",
            field: "modifiedby"
        }];

        $scope.filters = [{
            name: "Active",
            field: "active_merge_template",
            value: true,
            options: [{
                name: "Not Active",
                id: false
            }, {
                name: "Active",
                id: true
            }]
        }];
    }]);